import React, { useState } from 'react';
import _ from 'lodash';
import { Dialog, Picker } from '@tencent/spaui';

import { FIELD } from '../config';

const groupData = [];
_.forEach(FIELD, (e, key) => {
  groupData.push({
    value: key,
    label: key,
    describe: e,
  });
});

const HeaderComponent = (props) => {
  const { onClose, title } = props;

  return (
    <div>
      <button type="button" className="close" onClick={onClose}>
        <span aria-hidden="true">×</span>
      </button>
      <h4 className="modal-title">
        {title}
        <i className="spaui-icon icon-help"></i>
      </h4>
    </div>
  );
};

const EmptyComponent = () => <div>空</div>;
const MyDialog = (props) => {
  const [value, setValue] = useState(props.value);

  return (
    <Dialog
      backdrop
      type="normal"
      show={props.showDialog}
      onClose={props.onClose}
      onSubmit={() => {
        props.onSubmit(value);
      }}
      onCancel={props.onClose}
      title="标准字段设置"
      style={{
        width: '860px',
      }}
      HeaderComponent={HeaderComponent}
    >
      <div className="field-set">
        {/* <CheckboxGroup
                data={groupData}
                onChange={(e, value) => { setValue(value)}}
                value={value}
            /> */}
        <Picker
          search={false}
          selectionHeader={false}
          valueKey="value"
          data={groupData}
          value={value}
          EmptyComponent={EmptyComponent}
          onChange={(e, value) => {
            setValue(value);
          }}
          selectionEmptyLabel="请在左侧选择字段"
        />
      </div>
    </Dialog>
  );
};

export default MyDialog;
